import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='./'
      className='link footer__link'
    >
      This website is made using ReactJS and TailwindCSS while running on an Apache Web Server using Docker
    </a>
  </footer>
)

export default Footer
